export default __webpack_public_path__ + "static/media/otherworldlyjunction.1ce25279.jpg";